var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.icon,on:{"click":_vm.selected}},[_c('radio',{attrs:{"value":_vm.value,"name":"radio","bit":_vm.groupName}}),_vm._v(" "),_c('sprite',{attrs:{"name":_vm.icon}}),_vm._v("\n  "+_vm._s(_vm.groupName)+"\n")],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3319f50e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Messages/MultipleRadio.vue
// module id = null
// module chunks = 